module.exports = __webpack_public_path__ + "img/ZMB.41e4a6f6.svg";